import React from 'react';
import { SideSummary } from '@components/common';
import { useTierContext } from '../../hooks/useTierContext';
export const Analytics = () => {
    const { tier } = useTierContext();
    if (!tier)
        return null;
    return (React.createElement(SideSummary, null,
        React.createElement(SideSummary.Item, { title: "Analytics" },
            tier.statistics.membersCount,
            " total members")));
};
